import React from 'react';
import { Col, Row } from 'react-bootstrap';

export default function SettingItemRow({
  fieldName,
  value,
}: {
  fieldName: string;
  value: string;
}) {
  return (
    <Col sm={12} className="pt-2 pb-2">
      <Row>
        <Col className="fw-bold" sm={12}>
          {fieldName}:
        </Col>
        <Col>{value}</Col>
      </Row>
    </Col>
  );
}
